import { breadcrumbLd, Seo } from '../lib/seo';
import { SITE, fullAddress } from '../lib/site';
import { container } from '../lib/ui';

// NOTE: general template. Have it reviewed against your actual practices before launch.
const UPDATED = '2026-10-05';

export default function PrivacyPolicy() {
  return (
    <>
      <Seo
        title="Privacy Policy & Data Protection"
        description="How Green Valley Interiors collects, uses and protects the personal details you share through our consultation, contact and newsletter forms in Nagercoil, India."
        keywords={[
          'Green Valley Interiors privacy policy',
          'interior design enquiry data protection India',
          'how we use consultation form details',
          'newsletter unsubscribe and data deletion request',
          'Digital Personal Data Protection Act compliance',
        ]}
        path="/privacy-policy"
        jsonLd={[breadcrumbLd([['Privacy Policy', '/privacy-policy']])]}
      />
      <section className="bg-surface-cream border-b border-border-muted">
        <div className={`${container} pt-space-xl pb-space-lg md:pt-20`}>
          <span className="font-label-md text-label-md uppercase tracking-[0.2em] text-secondary">Legal</span>
          <h1 className="font-headline-xl text-headline-xl-mobile md:text-headline-xl text-primary mt-space-xs">
            Green Valley Interiors Privacy Policy
          </h1>
          <p className="font-body-md text-body-md text-on-surface-variant mt-space-sm">
            Last updated: <time dateTime={UPDATED}>5 October 2026</time>
          </p>
        </div>
      </section>
      <section className="bg-surface">
        <div className={`${container} py-space-xl md:py-20`}>
          <div className="prose-article max-w-3xl">
            <p>
              {SITE.name} (“we”, “us”) respects your privacy. This policy explains what personal information we collect
              through this website, why we collect it, and the choices you have.
            </p>
            <h2>Information we collect</h2>
            <ul>
              <li>
                <strong>Consultation and contact forms:</strong> your name, phone number, email address, project type,
                approximate area, location and any notes you choose to share.
              </li>
              <li>
                <strong>Newsletter:</strong> your email address (and name, if provided).
              </li>
              <li>
                <strong>Technical data:</strong> our hosting provider keeps standard server logs (such as IP address,
                browser type and pages requested) for security and reliability.
              </li>
            </ul>
            <p>This website does not use advertising or tracking cookies.</p>
            <h2>How we use your information</h2>
            <ul>
              <li>To respond to your enquiry and prepare consultations, estimates and design proposals.</li>
              <li>To send the newsletter you requested. You can unsubscribe at any time.</li>
              <li>To keep this website secure and prevent spam.</li>
            </ul>
            <p>We do not sell, rent or trade your personal information.</p>
            <h2>Sharing</h2>
            <p>
              Form submissions are delivered to our studio by email through our web hosting provider. We share project
              details with trusted contractors or suppliers only when needed to deliver work you have engaged us for.
            </p>
            <h2>Retention</h2>
            <p>
              We keep enquiry details for as long as needed to respond and, if you become a client, for the duration of the
              project and any warranty period. You may ask us to delete your information at any time.
            </p>
            <h2>Your rights</h2>
            <p>
              In line with India’s Digital Personal Data Protection Act, 2023, you may request access to, correction of, or
              deletion of your personal data, and withdraw consent for newsletters.
            </p>
            <h2>Contact</h2>
            <p>
              For any privacy request, email <a className="text-primary underline" href={`mailto:${SITE.email}`}>{SITE.email}</a>,
              call <a className="text-primary underline" href={`tel:${SITE.phoneE164}`}>{SITE.phoneDisplay}</a>, or write to us
              at {fullAddress}.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
